import React from 'react';
import './styleCreditCard.scss';
import { getImage } from '../../../../services/getAssets';
import { cardThemes } from '../../../../styles/Themes/cardThemes';
import { VALID_CHANNELS } from '../../../../utils/configUtils';

const CardType = Object.freeze({
  VISA: "visa",
  MASTERCARD: "mastercard",
  AMEX: "amex",
  ELO: "elo",
  UNKNOWN: "unknown",
});
const cardTypeMap = {
  "4": CardType.VISA,
  "5": CardType.MASTERCARD,
  "3": CardType.AMEX,
  "6": CardType.ELO,
};

const mockCardValidation = {
  cardType: (number) => {
    const firstDigit = number?.toString().charAt(0);
    return cardTypeMap[firstDigit] || CardType.UNKNOWN;
  },
  validateCardNumber: (number) => {
    return number?.toString().length >= 14;
  },
};
const logoType = VALID_CHANNELS;

export class CreditCardPreview extends React.Component {
  static defaultProps = {
    acceptedCards: [],
    locale: {
      valid: 'Validade',
    },
    placeholders: {
      name: 'Nome do Titular',
    },
    preview: false,
    channel: VALID_CHANNELS || 'xpay',
  };

  componentDidUpdate(prevProps) {
    const { callback, number } = this.props;

    if (prevProps.number !== number && typeof callback === 'function') {
      callback(this.options, mockCardValidation.validateCardNumber(number));
    }
  }

  get validChannel() {
    return VALID_CHANNELS.includes(this.props.channel)
      ? this.props.channel
      : 'padda';
  }

  get issuer() {
    const { issuer, preview } = this.props;
    return preview && issuer ? issuer.toLowerCase() : this.options.issuer;
  }

  get number() {
    const { number, preview } = this.props;
    if(preview) return number;

    let maxLength = this.options.maxLength;
    let nextNumber = this.sanitizeNumber(number, preview);
  
    if (maxLength > 12) {
      maxLength = nextNumber.length <= 12 ? 12 : maxLength;
    }
  
    nextNumber = this.truncateOrFill(nextNumber, maxLength);
    nextNumber = this.formatNumber(nextNumber);
  
    return nextNumber;
  }
  
  sanitizeNumber(number, preview) {
    let cleanNumber = typeof number === 'number' ? number.toString() : (number || '').replace(/[A-Za-z ]/g, '');
  
    if (isNaN(parseInt(cleanNumber, 10)) && !preview) {
      cleanNumber = '';
    }
  
    return cleanNumber;
  }
  
  truncateOrFill(number, maxLength) {
    let result = "";
  
    while (result.length < maxLength) {
      result += '•';
    }
  
    return result + number;
  }
  
  formatNumber(number) {
    return number.replace(/(.{4})/g, '$1 ').trim();
  }
  

  get expiry() {
    const { expiry = '', preview } = this.props;
    if(preview) return expiry;

    const [year, month] = expiry.split("-");
    return `${month}/${year.slice(-2)}`;;
  }

  get options() {
    const { number } = this.props;
    const issuer = mockCardValidation.cardType(number);

    let maxLength = 16;
    if (issuer === 'amex') {
      maxLength = 15;
    } else if (issuer === 'dinersclub') {
      maxLength = 14;
    } else if (['hipercard', 'mastercard', 'visa'].includes(issuer)) {
      maxLength = 19;
    }

    return {
      issuer,
      maxLength,
    };
  }

  render() {
    const { cvc, focused, locale, name, placeholders } = this.props;
    const { number, expiry } = this;

    const backgroundColor =
      cardThemes[this.validChannel]?.[this.issuer] || '#ffffff';

    return (
      <div
        key="Cards"
        className={`rccs channel-${this.validChannel}`}
        style={{ backgroundColor, borderRadius: '20px' }}
      >
        <div
          className={[
            'rccs__card',
            `rccs__card--${this.issuer}`,
            focused === 'cvc' && this.issuer !== 'amex'
              ? 'rccs__card--flipped'
              : '',
          ]
            .join(' ')
            .trim()}
        >
          <div
            className="rccs__card--front"
            style={{ backgroundColor, borderRadius: '20px' }}
          >
            <div className="rccs__chip" />
            <div
              className={`rccs__issuer logo-${logoType}`}           
            >
              <img
                src={getImage('logo-cartao.png')}
                alt="Logo do cartão"
                style={{
                  maxWidth: '100%',
                  maxHeight: '100%',
                  objectFit: 'contain',
                }}
              />
            </div>
            <div
              className={`rccs__number ${
                focused === 'number' ? 'rccs--focused' : ''
              }`}
              style={{
                color: 'var(--text-primary)',
              }}
            >
              {number}
            </div>
            <div
              className={`rccs__name ${
                focused === 'name' ? 'rccs--focused' : ''
              }`}
              style={{
                color: 'var(--text-primary)',
                fontWeight: 'bold',
                opacity: '1',
              }}
            >
              {name || placeholders?.name}
            </div>
            <div
              className={`rccs__expiry ${
                focused === 'expiry' ? 'rccs--focused' : ''
              }`}
            >
              <div
                className="rccs__expiry__valid"
                style={{
                  color: 'var(--text-primary)',
                  fontWeight: 'bold',
                  opacity: '1',
                }}
              >
                {locale?.valid}
              </div>
              <div
                className="rccs__expiry__value"
                style={{
                  color: 'var(--text-primary)',
                  fontWeight: 'bold',
                  opacity: '1',
                }}
              >
                {expiry}
              </div>
            </div>
            {this.issuer === 'amex' && (
              <div
                className={`rccs__cvc__front ${
                  focused === 'cvc' ? 'rccs--focused' : ''
                }`}
              >
                {cvc}
              </div>
            )}
          </div>
          <div className="rccs__card--back" style={{ backgroundColor }}>
            <div className="rccs__stripe" />
            <div className="rccs__signature" />
            <div
              className={`rccs__cvc ${
                focused === 'cvc' ? 'rccs--focused' : ''
              }`}
            >
              {cvc}
            </div>
            <div
              className="rccs__issuer"
              style={{
                position: 'absolute',
              }}
            >
              <img src={getImage('logo-preto.png')} alt="Logo" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CreditCardPreview;
